import {
  archive_icon,
  delete_icon,
  plus_blue_icon,
} from "assets/icons/icons";

const items = [
  {
    key: "1",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>New task</p>
      </div>
    ),
  },
  {
    key: "2",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>New expence</p>
      </div>
    ),
  },
  {
    key: "3",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>Invoice project</p>
      </div>
    ),
  },
  {
    key: "4",
    label: (
      <div className="flex items-center pt-2 pr-5 pb-1">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>Clone</p>
      </div>
    ),
  },
  {
    key: "5",
    label: (
      <div className="flex items-center pt-3 pr-5 border-t-[1px] border-[rgba(0,0,0,.1)]">
        <img src={archive_icon} alt="" className="mr-2" width={20} />
        <p>Pause</p>
      </div>
    ),
  },
  {
    key: "6",
    label: (
      <div className="flex items-center py-2 pr-5">
        <img src={delete_icon} alt="" className="mr-2" width={15} />
        <p>Delete</p>
      </div>
    ),
  },
];

const detailItems = [
  {
    key: "1",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>Edit project</p>
      </div>
    ),
  },
  {
    key: "2",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>Copy project</p>
      </div>
    ),
  },
  {
    key: "3",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>Mark as not started</p>
      </div>
    ),
  },
  {
    key: "4",
    label: (
      <div className="flex items-center pt-2 pr-5 pb-1">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>Mark as on hold</p>
      </div>
    ),
  },
  {
    key: "5",
    label: (
      <div className="flex items-center pt-2 pr-5 pb-1">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>Mark as cancels</p>
      </div>
    ),
  },
  {
    key: "6",
    label: (
      <div className="flex items-center pt-2 pr-5 pb-1">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>Mark as finish</p>
      </div>
    ),
  },
  {
    key: "7",
    label: (
      <div className="flex items-center pt-3 pr-5 border-t-[1px] border-[rgba(0,0,0,.1)]">
        <img src={archive_icon} alt="" className="mr-2" width={20} />
        <p>Archive project</p>
      </div>
    ),
  },
  {
    key: "8",
    label: (
      <div className="flex items-center py-2 pr-5">
        <img src={delete_icon} alt="" className="mr-2" width={15} />
        <p>Delete project</p>
      </div>
    ),
  },
];

export { items, detailItems };
